import { TextLabel } from '@core/components/Inputs';
import { formatTELEFONE } from '@format';
import React from 'react';

const Telefone = (props) => {
  const { index, telefone, contatoIndex } = props;
  return (
    <TextLabel
      format={formatTELEFONE}
      id={`pessoa.contatos${contatoIndex}.telefonesAdicionais[${index}].numero`}
      value={telefone.codigoPais ? `${telefone.codigoPais} ${telefone.numero}` : telefone.numero}
      label={index === 0 ? 'Telefones adicionais' : ''}
    />
  );
};

const TelefoneAdicionalVisualizar = (props) => {
  const { contatoIndex, telefonesAdicionais = [] } = props;

  return telefonesAdicionais.map((item, index) => {
    return <Telefone key={index} contatoIndex={contatoIndex} telefone={item} index={index} />;
  });
};

export default TelefoneAdicionalVisualizar;
